import { OptionData } from "types"

export const VANGUARD_MAJORS: OptionData = [
  "Undeclared",
  "Accounting",
  "Biology B.S.",
  "Biology: Biomedical Science",
  "Biology: Ecology",
  "Biology: Neurobiology",
  "Biotechnology",
  "Business Administration",
  "Communication: Film and Visual Storytelling",
  "Communication: Social Media and Content Creation",
  "Computer Science",
  "Criminal Justice",
  "Digital Marketing and Public Relations",
  "Engineering Physics",
  "English",
  "History and Political Science",
  "Human Biology",
  "Kinesiology: Health and Human Performance",
  "Kinesiology: Pre-Health Professions",
  "Kinesiology: Sport and Fitness Management",
  "Kinesiology: Sports Ministry",
  "Liberal Studies",
  "Marketing",
  "Music",
  "Music and Worship Arts: Commercial Music Artistry",
  "Music and Worship Arts: Commercial Studio Production",
  "Music and Worship Arts: Ministry Leadership",
  "Music: Pre-Teacher Certificate",
  "Nursing",
  "Organizational Communication",
  "Pre-Nursing/Nursing",
  "Psychology",
  "Psychology: Health Psychology",
  "Sociology",
  "Theatre Arts: Musical Theatre",
  "Theatre Arts: Stage and Screen Acting/Directing",
  "Theatre Arts: Technical Production",
  "Theology: Biblical Studies",
  "Theology: General Christian Studies",
  "Theology: Intercultural Studies",
  "Theology: Ministry and Leadership",
  "Theology: Ministry and Management",
  "Theology: Pastoral Leadership Studies",
]
